


























































import Vue, { PropType } from 'vue';
import Input from '../common/Input/Input.vue';
import Select from '../common/Select/Select.vue';
import LabelsetSchemaRulesView from './LabelsetSchemaRulesView.vue';
import Button from '../common/Button/Button.vue';

interface labelDataI {
  labelName: string;
  example: string;
  dataType: string;
  ruleNum: number;
  showRulePage: boolean;
}

export default Vue.extend({
  props: {
    labelNameData: {
      type: Array as PropType<string[]>,
    },
    exampleData: {
      type: Array as PropType<string[]>,
    },
    getResult: {
      type: Boolean,
    },
  },
  components: {
    Input,
    Select,
    LabelsetSchemaRulesView,
    Button,
  },
  data(): {
    computedData: labelDataI[];
  } {
    return {
      computedData: [],
    };
  },
  created() {
    let initialComputedData: any = [];
    (this.exampleData as string[]).forEach(
      (exampleName: string, idx: number) => {
        if (exampleName !== '') {
          initialComputedData.push({
            labelName: this.labelNameData[idx],
            example: exampleName,
            dataType: 'string',
            ruleNum: 0,
            showRulePage: false,
          });
        }
      },
    );
    this.computedData = initialComputedData;
  },
  methods: {
    onClickNextButton() {
      let labelSchema: {
        type: string;
        required: string[];
        additionalProperties: boolean;
        properties: any;
      } = {
        type: 'object',
        required: this.computedData.map((data: labelDataI) => data.labelName),
        properties: {},
        additionalProperties: true,
      };
      let properties = this.labelNameData;

      //각 rulesView에 속해 있는 instance에 대해
      (
        this.$refs.rulesView as InstanceType<typeof LabelsetSchemaRulesView>[]
      ).forEach((element: InstanceType<typeof LabelsetSchemaRulesView>) => {
        //해당 rulesView가 몇 번째 index인지를 구한 뒤
        const index: number = parseInt(
          (element.$el as HTMLElement).dataset.index as string,
        );

        //해당 index에 속하는 labelName에 대한 property를 update
        labelSchema.properties[this.computedData[index].labelName] = {
          ...this.normalizeValueToJSON(element.showRules, element.value),
          type: this.computedData[index].dataType,
        };

        //해당 index의 example 값을 바탕으로 변경되어야 할 properties의 요소를 변경
        const indexProperties = this.exampleData.indexOf(
          this.computedData[index].example,
        );
        properties[indexProperties] = this.computedData[index].labelName;
      });

      this.$emit('pushResult', { ok: true, labelSchema, properties });
    },
    normalizeValueToJSON(
      showRules: boolean[],
      value: {
        pattern: string;
        category: string;
        minMax: {
          minimum: number | undefined;
          maximum: number | undefined;
        };
      },
    ) {
      let responseValue: {
        pattern?: string;
        enum?: string[];
        minimum?: number;
        maximum?: number;
      } = {};

      if (showRules[0]) {
        responseValue['pattern'] = value.pattern;
      }
      if (showRules[1]) {
        responseValue['enum'] = value.category.split('/');
      }
      if (showRules[2]) {
        if (value.minMax.minimum !== undefined) {
          responseValue['minimum'] = value.minMax.minimum;
        }

        if (value.minMax.maximum !== undefined) {
          responseValue['maximum'] = value.minMax.maximum;
        }
      }

      return responseValue;
    },
    onClickShowRulePageButton(target: HTMLElement) {
      /*
      const selectedSchemaRulesView = this.$refs.rulesView[index];

      console.log(selectedSchemaRulesView.offsetHeight);

      if (selectedSchemaRulesView.clientHeight > 0) {
        selectedSchemaRulesView.style.height = `0px`;
      } else {
        selectedSchemaRulesView.style.height =
          selectedSchemaRulesView.clientHeight + `px`;
      }
      */
      if (!target.dataset.index) {
        return;
      }

      const index = parseInt(target.dataset.index);

      this.computedData[index]['showRulePage'] =
        !this.computedData[index]['showRulePage'];
    },
  },
  watch: {
    getResult: function (getResult) {
      if (getResult === true) {
        this.onClickNextButton();
      }
    },
  },
});
